export default "__VITE_ASSET__CPJFNFXb__"